import util from '@bmp-vue/core/api/util'
const controller = 'Giromais'
const ctrl = Object.assign({}, util.GetCrud(controller, ['none']), {
  Get (anoFab, th) {
    var anoFim = anoFab >= th.$param.AnoFim_Inicio.anoFim ? anoFab : th.$param.AnoFim_Inicio.anoFim
    var anoInicio = anoFab <= th.$param.AnoFim_Inicio.anoInicio ? anoFab : th.$param.AnoFim_Inicio.anoInicio

    var tabelaTaxas = []
    if (th.$param.TabelaTaxas[0].id) {
      tabelaTaxas = th.$param.TabelaTaxas.find(p => p.id === (th.model.PropostaDadosVeiculo.TipoSegmento || th.model.PropostaDadosVeiculo.TipoPlaca || 1)).value
    } else {
      tabelaTaxas = th.$param.TabelaTaxas
    }
    const tabela = tabelaTaxas.map(l => {
      if (l.anoInicio === 'anoInicio') {
        l.anoInicio = anoInicio
      } else if (l.anoFim === 'anoFim') {
        l.anoFim = anoFim
      }
      return l
    })
    return tabela
  },
  GetItem (modelo, prazo, anoFab, th) {
    var result = null
    var vlrEntradaDecimal = null
    if (anoFab && prazo && (modelo || modelo === 0)) {
      if (th.$param.FiltraTaxaPorEntrada) {
        vlrEntradaDecimal = (th.model.VlrEntrada / th.model.VlrProdutoBem).toFixed(2)
        vlrEntradaDecimal = parseFloat(vlrEntradaDecimal.substring(0, 3))
        vlrEntradaDecimal = vlrEntradaDecimal >= 0.5 ? 0.5 : vlrEntradaDecimal
      }

      const item = ctrl.Get(anoFab, th).find(p => anoFab <= p.anoFim && anoFab >= p.anoInicio && prazo === p.prazo && (th.$param.FiltraTaxaPorEntrada ? p.entrada === vlrEntradaDecimal : true))
      var mod = Object.keys(item).find(l => {
        if (l.includes(modelo)) {
          return l
        }
      })
      result = { anoInicio: item.anoInicio, anoFim: item.anoFim, prazo: item.prazo, taxa: item[mod], entrada: item.entrada }
    } else if (th.model.PropostaDadosVeiculo.AnoFab) {
      anoFab = th.model.PropostaDadosVeiculo.AnoFab
      const item = ctrl.Get(anoFab, th).find(p => anoFab <= p.anoFim && anoFab >= p.anoInicio).entrada
      result = item
    }
    return result
  },
  GetCampoAuxiliar (th, codigoProposta) {
    const dto = { parameters: [{ name: 'CodigoProposta', value: codigoProposta }] }
    return th.$api.Multiplo.Post('ListPropostaCampoAuxiliar', dto)
  },
  VlrEntradaRules (th) {
    var response = [
      th.model.VlrEntrada < th.model.VlrProdutoBem || 'O Valor da Entrada deve ser menor que Valor do Veículo'
    ]
    if (!th.$param.FiltraTaxaPorEntrada) {
      if ((th.model.ModeloComissao || th.model.ModeloComissao === 0) && th.model.Parcelas && th.model.PropostaDadosVeiculo.AnoFab) {
        var entrada = ctrl.GetItem(th.model.ModeloComissao, th.model.Parcelas, th.model.PropostaDadosVeiculo.AnoFab, th).entrada
        response.push(th.model.VlrEntrada >= (th.model.VlrProdutoBem * entrada).toFixed(2) || 'O Valor da Entrada deve ser pelo menos ' + (entrada * 100) + '% do Valor do Veículo')
        return response
      }
    } else {
      response.push(th.model.VlrEntrada >= (th.model.VlrProdutoBem * th.$param.VlrMinEntrada) || 'O Valor da Entrada deve ser pelo menos ' + (th.$param.VlrMinEntrada * 100) + '% do Valor do Veículo')
    }
    return response
  },
  GetTaxa (th) {
    var taxa = 0
    const tx = ctrl.GetItem(th.model.ModeloComissao, th.model.Parcelas, th.model.PropostaDadosVeiculo.AnoFab, th)
    if (tx) {
      taxa = tx.taxa
    }
    th.$set(th.model, 'PercJurosMensal', taxa)
  },
  GetAnoLimite (th) {
    return typeof th.$param.Veiculos_QtdeAnoLimite === 'object' ? th.$param.Veiculos_QtdeAnoLimite[th.model.PropostaDadosVeiculo.TipoSegmento || th.model.PropostaDadosVeiculo.TipoPlaca || 1] : th.$param.Veiculos_QtdeAnoLimite
  },
  ChangeVlrProdutoBem (th, value) {
    let vlrEntrada = 0
    const PercEntrada = ctrl.GetItem(null, null, null, th)
    if (value) {
      value = th.$api.UI.Parse.Decimal(value)
      vlrEntrada = parseFloat((value * PercEntrada).toFixed(2))
    }
    th.$set(th.model, 'VlrEntrada', vlrEntrada)
  },
  SavePropostaCampoAuxiliar (th) {
    const campos = []

    if ([null, undefined].indexOf(th.model.PropostaDadosVeiculo.ZeroKM) < 0) { campos.push({ CodigoProposta: th.model.Codigo, NomeCampo: 'PROPOSTAVEICULO_ZEROKM', ValorCampo: th.model.PropostaDadosVeiculo.ZeroKM }) }
    if (th.model.PropostaDadosVeiculo.TipoSegmento || th.model.PropostaDadosVeiculo.TipoPlaca) { campos.push({ CodigoProposta: th.model.Codigo, NomeCampo: 'PROPOSTAVEICULO_TIPOSEGMENTO', ValorCampo: th.model.PropostaDadosVeiculo.TipoSegmento || th.model.PropostaDadosVeiculo.TipoPlaca }) }
    if ([null, undefined].indexOf(th.model.ModeloComissao) < 0) { campos.push({ CodigoProposta: th.model.Codigo, NomeCampo: 'PROPOSTA_MODELOCOMISSAO', ValorCampo: th.model.ModeloComissao }) }
    if ([null, undefined].indexOf(th.model.ObservacaoVendedor) < 0) { campos.push({ CodigoProposta: th.model.Codigo, NomeCampo: 'PROPOSTA_OBSERVACAOVENDEDOR', ValorCampo: th.model.ObservacaoVendedor }) }
    if ([null, undefined].indexOf(th.model.DtoConsultaMotor) < 0) { campos.push({ CodigoProposta: th.model.Codigo || th.model.Codigo, NomeCampo: 'PROPOSTA_CONSULTAMOTOR', ValorCampo: JSON.stringify(th.model.DtoConsultaMotor) }) }

    if (campos.length > 0) { th.$api.Multiplo.Post('SavePropostaCampoAuxiliar', { dto: campos }) }
  },
  ImportaAssinante (th, request, importEmitente) {
    if (importEmitente) {
      th.$api.Multiplo.Post('InsertCCBDigitalAssinatura', request).then(function (response) {
        th.$api.UI.PostAction(response, 'Importação realizada com sucesso!')
      })
    }
    th.$api.Multiplo.Post('ImportarCCBDigitalAssinatura', { guidID: request.dto.CodigoProposta }).then((response) => {
      if (th.$api.UI.PostAction(response, 'Importação realizada com sucesso!')) {
      }
    })
  },
  CalculaGridParcelas (th, dto, callback) {
    th.$api.Multiplo.Post('CalculaGridParcelasSimplificadoPrice', dto).then(res => {
      if (th.$api.UI.PostLoadData(res, true)) {
        if (callback) callback(res)
      }
    })
  },
  CarregaDiasAcrescimo (th, value) {
    if (value && !ctrl.AllowedDates(th, value)) {
      let date = new Date(value)
      date = th.$api.UI.Date.AddDay(date, 1).toISOString().substr(0, 10)
      th.$set(th.model, 'DtPrimeiroVencto', date)
      th.carregaDiasAcrescimo(date)
      return
    }
    th.model.nroDiasAcrescimoPrimPagto = th.$api.UI.Date.DaysBetween(th.$api.UI.Date.AddMonth(new Date(), 1), value)
  },
  AllowedDates (th, value) {
    if (th && value) {
      return ![0, 6].includes(th.$api.UI.Parse.Date(value).getDay())
    } else {
      const date = new Date(`${th} 00:00:00`)
      const dayOfWeek = date.getDay()
      const isWeekend = [0, 6].includes(dayOfWeek)
      if (!isWeekend) { return date }
    }
  },
  bureaus: [
    { id: 0, value: 'databusca', text: 'DATA BUSCA' },
    { id: 1, value: 'serasa', text: 'SERASA' },
    { id: 2, value: 'scr', text: 'SCR BACEN' },
  ],
  validaBureaus (th, documentoCliente, bureaus, callback) {
    var dtoDataBusca = {
      consulta: {
        Documento: documentoCliente,
      },
    }

    const dataAtual = th.$api.UI.Format.Date(
      th.$api.UI.Date.AddDay(new Date(), -45),
      'yyyy-MM'
    )

    var dataBaseAno = dataAtual.split('-')[0]
    var dataBaseMes = dataAtual.split('-')[1]
    var dtoScr = {
      consulta: {
        Documento: documentoCliente,
        DataBaseAno: dataBaseAno,
        DataBaseMes: dataBaseMes,
      },
    }

    var dtoSerasa = {
      consulta: {
        Documento: documentoCliente,
      },
    }
    Promise.all([
      !bureaus.databusca || bureaus.databusca.HasError ? th.$api.Multiplo.Post('ConsultaDataBusca', dtoDataBusca) : null,
      !bureaus.scr || bureaus.scr.HasError ? th.$api.Multiplo.Post('ConsultaSCR', dtoScr) : null,
      !bureaus.serasa || bureaus.serasa.HasError ? th.$api.Multiplo.Post('ConsultaSerasa', dtoSerasa) : null,
    ]).then(response => {
      bureaus.databusca = response[0] || bureaus.databusca
      bureaus.scr = response[1] || bureaus.scr
      bureaus.serasa = response[2] || bureaus.serasa
      th.$set(th.model, 'DadosBureau', bureaus);
      callback()
    })
  },
  ModeloCalculoEnum: {
    Price: 1,
    SAC: 2
  },
  ListaSituacaoDataBaseAprovada: [
    2, // Aprovada
    6, // Finalizada
    7, // Conferida
    8, // Liberada
    9, // Paga
    10, // Cedida
    11 // PendentePagamento
  ],
  SituacaoDataBaseAprovada: function (situacao) {
    var listaSituacao = ctrl.ListaSituacaoDataBaseAprovada
    return listaSituacao.includes(situacao)
  },
  Indexador: [
    { value: 1, text: 'CDI' },
    { value: 2, text: 'SELIC' },
    { value: 3, text: 'IPCA' },
    { value: 4, text: 'PTAX' },
    { value: 5, text: 'IGP-M' }
  ],
  TipoErroGravameEnum: {
    Externo: 1,
    Interno: 2
  },
})

export default ctrl
